import React from "react";
import SadGIF from "@/assets/images/sad.gif";
import { Loader2, Trash2, X } from "lucide-react";
import CustomModal from "./CustomModal";
import SecondaryButton from "../Button/SecondaryButton";
import { PrimaryButton } from "../Button/PrimaryButton";

const DeleteConfirmationModal = ({
  showConfirmDelete,
  onClose,
  title,
  description,
  onDelete,
  deleteButtonText = "Delete",
  cancelButtonText = "Cancel",
  width,
  isDeleting,
  icon,
  useGif = true,
}) => {
  const renderIcon = () => {
    // If user passes a React element
    if (React.isValidElement(icon)) {
      return icon;
    }

    // If user passes a component
    if (typeof icon === "function") {
      const IconComponent = icon;
      return <IconComponent size={56} />;
    }

    // Default fallback
    if (useGif) {
      return <img src={SadGIF} alt="sadgif" className="h-14 w-14" />;
    }

    return null;
  };

  return (
    <CustomModal isOpen={showConfirmDelete} onClose={onClose} width={width}>
      <div className="flex justify-end w-full">
        <button
          className="p-1 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full absolute right-6 top-6 text-gray-800 dark:text-gray-200 transition-colors"
          onClick={onClose}
        >
          <X size={20} />
        </button>
      </div>

      <div className="flex flex-col gap-3.5 w-full justify-center items-center">
        {/* title & description */}
        <div className="flex flex-col gap-1.5 items-center justify-center">
          {renderIcon()}

          <h3 className="text-gray-900 dark:text-gray-100 font-bold text-base text-center">
            {title}
          </h3>

          <p className="text-gray-500 dark:text-gray-400 text-xs text-center">{description}</p>
        </div>

        {/* buttons */}
        <div className="flex gap-3.5 mx-2 justify-center w-full">
          <SecondaryButton
            textColor="dark"
            title={isDeleting ? "Deleting..." : deleteButtonText}
            icon={
              isDeleting ? (
                <Loader2 className="animate-spin text-error-500" size={16} />
              ) : (
                <Trash2 className="text-error-500" size={16} />
              )
            }
            className="w-full"
            onClick={onDelete}
            disabled={isDeleting}
          />

          <PrimaryButton
            startContent={false}
            className="w-full"
            onClick={onClose}
            disabled={isDeleting}
          >
            {cancelButtonText}
          </PrimaryButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default DeleteConfirmationModal;
